<template>
  <v-row :class="{ animate: animate }" justify="center">
    <vertical-slots-machine
      v-for="(result, index) in digits"
      class="col col-auto"
      :key="index"
      round-slots
      :speed="20 + index * [3, 7, 8][Math.floor(Math.random() * 3)]"
      :stop-number="parseInt(result, 10)"
      :spin="spinArr[index]"
    >
    </vertical-slots-machine>
  </v-row>
</template>

<script>
import VerticalSlotsMachine from "./VerticalSlotsMachine.vue";
import { Howl } from "howler";
import SpinSound from "./Casino slot machine tone - winning count - mechanical and electronic spinning tone 4.mp3";

export default {
  name: "SlotMachine",
  props: {
    digits: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      spinning: false,
      spinSound: SpinSound,
      spinArr: this.digits.split("").map(() => false),
      sound: new Howl({
        src: SpinSound,
        volume: 0.4,
        loop: false,
        autoPlay: false
      }),
      animate: false
    };
  },
  components: {
    VerticalSlotsMachine
  },
  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async start() {
      for (const [i] of this.digits.split("").entries()) {
        this.$set(this.spinArr, i, true);
      }
      // this.spinning = true;
      this.sound.play();
    },
    async stop() {
      for (const [i] of this.digits.split("").entries()) {
        await this.sleep(3000);
        this.$set(this.spinArr, i, false);
      }
      return new Promise(resolve => {
        setTimeout(() => {
          this.sound.stop();
          setTimeout(() => {
            this.animate = true;
          }, 1000);
          resolve();
        }, 3500 + 400 * this.digits.length);
      });
    }
  }
};
</script>

<style scoped>
@keyframes zoominoutsinglefeatured {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.2, 1.2);
  }
  100% {
    transform: scale(1, 1);
  }
}

.animate {
  animation: zoominoutsinglefeatured 1s infinite;
}
</style>
